import { useEffect } from 'react';
import { NegocioConfig } from "../../configuracion/Empresa";
import ModoOscuro from "../plantilla/ModoOscuro";
import CerrarSesionButton from '../contenedores/CerrarSesion';

const Header = () => {
    
    useEffect(() => {
        document.body.classList.add('layout-top-nav');
        document.body.style.height = 'auto';
        return () => {
            document.body.classList.remove('layout-top-nav');
            document.body.style.height = '';
        };
    }, []);

    return (
        <nav className="main-header navbar navbar-expand-lg navbar-dark border-bottom shadow-sm sticky-top" style={{ backgroundColor: "#2d9053ff" }}>
            <div className="container-fluid px-3 px-md-2">

                <a href="/login" className="navbar-brand d-flex align-items-center">
                    <img
                        src={NegocioConfig.imagen}
                        alt="Logo de la Empresa"
                        className="me-2 rounded-circle border border-1 border-white"
                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                    />
                    <span className="fw-bold text-white fs-5 mx-3">{NegocioConfig.nombre || "BarbeShop Vikingos"}</span>
                </a>
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-none d-lg-flex align-items-center">
                    <li className="nav-item">
                        <ModoOscuro />
                    </li>
                    <li className="nav-item">
                        <CerrarSesionButton />
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Header;